<template>
  <div class="lg:flex items-center">
    <div class="h-2 relative overflow-hidden bg-secondary flex-1">
      <div
        class="transition-transform duration-500 ease-linear absolute w-full h-full top-0 bg-mono-200"
        v-bind:style="{ transform: 'translateX(' + percentage + '%)' }"
      ></div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    percentage: function() {
      // this is added to avoid layout shift during initialization
      if (this.total <= 1) {
        return 14;
      }

      return Math.round((this.active / this.total) * 100);
    },
  },
  props: {
    total: {
      Type: Number,
      Required: true,
    },
    active: {
      Type: Number,
      Required: true,
    },
  },
};
</script>
